import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal2);

const AdminPanelUsers = (props) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usersSend, setUsersSend] = useState([]);
  const [usersSend2, setUsersSend2] = useState([]);
  const [usersSend4, setUsersSend4] = useState([]);
  const [usersSend3, setUsersSend3] = useState([]);
  const [usersSend5, setUsersSend5] = useState([]);
  const [usersSend6, setUsersSend6] = useState([]);
  const [usersSend7, setUsersSend7] = useState([]);
  const [taskReport, setTaskReport] = useState([]);
  const [sygnReport, setSygnReport] = useState([]);
  const [stsReport, setSTSReport] = useState([]);

  const fetchUsersSend = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend(data);
        fetchUsersSend2();
      })
      .catch((error) => {});
  };

  const fetchUsersSend2 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend2(data);
        fetchUsersSend3();
      })
      .catch((error) => {});
  };

  const fetchUsersSend3 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend3(data);
        fetchUsersSend4();
      })
      .catch((error) => {});
  };

  const fetchUsersSend4 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend4", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend4(data);
        fetchTaskReport();
      })
      .catch((error) => {});
  };

  const fetchTaskReport = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getTaskReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTaskReport(data);
        fetchUsersSygnReport();
      })
      .catch((error) => {});
  };

  const fetchUsersSygnReport = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSygnReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSygnReport(data);
        fetchUsersSTSReport();
      })
      .catch((error) => {});
  };

  const fetchUsersSTSReport = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSTSReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSTSReport(data);
        fetchUsersSend5();
      })
      .catch((error) => {});
  };

  const fetchUsersSend5 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend5", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend5(data);
        fetchUsersSend6();
      })
      .catch((error) => {});
  };

  const fetchUsersSend6 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend6", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend6(data);
        fetchUsersSend7();
      })
      .catch((error) => {});
  };

  const fetchUsersSend7 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend7", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend7(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTaskTypes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchUsersSend();
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTaskTypes();
  };

  useEffect(() => {
    getData();
  }, []);

  const changeRights = async (e) => {
    var value = +e.target.value === 1 ? "0" : "1";
    var field = e.target.attributes.field.value;
    var userId = e.target.attributes.fieldUID.value;

    var body = {
      field: field,
      value: value,
      id: userId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const changeRightsText = (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: e.currentTarget.attributes.desc.value,
      input: "text",
      inputPlaceholder: e.currentTarget.value,
      inputValue: e.currentTarget.value,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          field: field,
          value: value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsText1 = (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: e.currentTarget.attributes.desc.value,
      input: "text",
      inputPlaceholder: e.currentTarget.value,
      inputValue: e.currentTarget.value,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          field: field,
          value: value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateTaskReportTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const deleteUserAccept = (e) => {
    var name = e.currentTarget.attributes.field.value;
    var initials = e.currentTarget.attributes.desc.value;
    var userId = e.currentTarget.attributes.fieldUID.value;
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć pracownika?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {
          name: name,
          id: userId,
          initials: initials,
        };

        await fetch("https://apidevkppp.ftpeople.pl/deleteUserAdmin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteUser = async (e) => {
    var name = e.currentTarget.attributes.field.value;
    var initials = e.currentTarget.attributes.desc.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var body = {
      name: name,
      id: userId,
      initials: initials,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteUserAdmin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const changeRightsUser = (e) => {
    var model = [];
    var team = e.currentTarget.value;

    users
      .filter((el) => el.team.includes(team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;

        var body = {
          user: us,
          team: team,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsUser2 = (e) => {
    var model = [];
    var team = e.currentTarget.value;

    users
      .filter((el) => el.team.includes(team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;

        var body = {
          user: us,
          team: team,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend2", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsUser4 = (e) => {
    var model = [];
    var team = e.currentTarget.value;

    users
      .filter((el) => el.team.includes(team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;

        var body = {
          user: us,
          team: team,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend4", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsUser3 = (e) => {
    var model = [];
    var team = e.currentTarget.value;

    users
      .filter((el) => el.team.includes(team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;

        var body = {
          user: us,
          team: team,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend3", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsRole = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var model = [];
    model["user"] = "user";
    model["admin"] = "admin";
    model["consultantTele"] = "konsultant telefoniczny";
    model["consultantTeleSKD"] = "konsultant telefoniczny SKD";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsTeam1 = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var model = [];
    model["1"] = "1";
    model["2"] = "2";
    model["1,2"] = "1,2";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const changeRightsTeam2 = async (e) => {
    var field = e.currentTarget.attributes.field.value;
    var userId = e.currentTarget.attributes.fieldUID.value;

    var model = [];
    model["1"] = "1";
    model["2"] = "2";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body = {
          field: field,
          value: result.value,
          id: userId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersTable", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Prawa: wyszukiwanie</th>
        <th>Prawa: kalendarz</th>
        <th>Prawa: dodawnia zadań</th>
        <th>Prawa: dodawnia rozpraw</th>
        <th>Prawa: akceptacja rozpraw</th>
        <th>Prawa: przypisanie osoby do zadania</th>
        <th>Prawa: edycja rozprawy</th>
        <th>Prawa: historia do rozprawy</th>
        <th>Prawa: przypisanie prawnika do rozprawy</th>
        <th>Prawa: uzupełnienie wyniku rozprawy</th>
        <th>Prawa: uzupełnienie uwag do rozprawy</th>
        <th>Prawa: usuwanie rozprawy</th>
        <th>Prawa: dodawanie sprawy</th>
        <th>Prawa: usuwanie sprawy</th>
        <th>Prawa: widok obu zespołów</th>
        <th>Prawa: prognozowany przychód</th>
        <th>Prawa: przypisywanie grup do zadań</th>
        <th>Prawa: grupowe odbieranie doręczeń</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.wyszukaj === "1" ? true : false}
                fieldUID={el.id}
                field="wyszukaj"
                value={el.wyszukaj}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.kalendarz === "1" ? true : false}
                fieldUID={el.id}
                field="kalendarz"
                value={el.kalendarz}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieDodawanie === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieDodawanie"
                value={el.zadanieDodawanie}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaDodawanie === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaDodawanie"
                value={el.rozprawaDodawanie}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaAkceptacja === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaAkceptacja"
                value={el.rozprawaAkceptacja}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadaniePrzypisanieUsera === "1" ? true : false}
                fieldUID={el.id}
                field="zadaniePrzypisanieUsera"
                value={el.zadaniePrzypisanieUsera}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaEdycja === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaEdycja"
                value={el.rozprawaEdycja}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaHistoria === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaHistoria"
                value={el.rozprawaHistoria}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaPrawnik === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaPrawnik"
                value={el.rozprawaPrawnik}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaWynik === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaWynik"
                value={el.rozprawaWynik}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaUwagi === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaUwagi"
                value={el.rozprawaUwagi}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozprawaUsun === "1" ? true : false}
                fieldUID={el.id}
                field="rozprawaUsun"
                value={el.rozprawaUsun}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.dodajSprawe === "1" ? true : false}
                fieldUID={el.id}
                field="dodajSprawe"
                value={el.dodajSprawe}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.usunSprawe === "1" ? true : false}
                fieldUID={el.id}
                field="usunSprawe"
                value={el.usunSprawe}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.bothTeam === "1" ? true : false}
                fieldUID={el.id}
                field="bothTeam"
                value={el.bothTeam}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.sprPrzych === "1" ? true : false}
                fieldUID={el.id}
                field="bothTeam"
                value={el.sprPrzych}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.przypisanieGrupDoZadan === "1" ? true : false}
                fieldUID={el.id}
                field="przypisanieGrupDoZadan"
                value={el.przypisanieGrupDoZadan}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.devs === "1" ? true : false}
                fieldUID={el.id}
                field="devs"
                value={el.devs}
                onChange={changeRights}
              />
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableSeventh = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Prawa: menu zlecenia załozenia spraw</th>
        <th>Prawa: cofanie zlecenia załozenia sprawy</th>
        <th>Prawa: sprzedaż</th>
        <th>Prawa: admin sprzedaż</th>
        <th>Prawa: sprzedaż - zakładanie spraw</th>
        <th>Prawa: przydzielanie spraw</th>
        <th>Prawa: archiwizacja spraw</th>
        <th>Prawa: zmiana zespołu spraw</th>
        <th>Prawa: super admin sprzedaż</th>
        <th>Prawa: generowanie umowy</th>
        <th>Prawa: materiały</th>
        <th>Prawa: materiały admin</th>
        <th>Prawa: wyszukiwanie klientów po notatce</th>
        <th>Prawa: edyzcja zadań "Apelacja"</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.sprzedazZlecSpraweFinish === "1" ? true : false}
                fieldUID={el.id}
                field="sprzedazZlecSpraweFinish"
                value={el.sprzedazZlecSpraweFinish}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.cofnijZlecSpraweFinish === "1" ? true : false}
                fieldUID={el.id}
                field="cofnijZlecSpraweFinish"
                value={el.cofnijZlecSpraweFinish}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.sprzedaz === "1" ? true : false}
                fieldUID={el.id}
                field="sprzedaz"
                value={el.sprzedaz}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.adminSprzedaz === "1" ? true : false}
                fieldUID={el.id}
                field="adminSprzedaz"
                value={el.adminSprzedaz}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.sprzedazZlecSprawe === "1" ? true : false}
                fieldUID={el.id}
                field="sprzedazZlecSprawe"
                value={el.sprzedazZlecSprawe}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.dostep === "1" ? true : false}
                fieldUID={el.id}
                field="dostep"
                value={el.dostep}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.archSpraw === "1" ? true : false}
                fieldUID={el.id}
                field="archSpraw"
                value={el.archSpraw}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.switchSpraw === "1" ? true : false}
                fieldUID={el.id}
                field="switchSpraw"
                value={el.switchSpraw}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.salesSuperAdmin === "1" ? true : false}
                fieldUID={el.id}
                field="salesSuperAdmin"
                value={el.salesSuperAdmin}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.generowanieUmowy === "1" ? true : false}
                fieldUID={el.id}
                field="generowanieUmowy"
                value={el.generowanieUmowy}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.materials === "1" ? true : false}
                fieldUID={el.id}
                field="materials"
                value={el.materials}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.adminMaterials === "1" ? true : false}
                fieldUID={el.id}
                field="adminMaterials"
                value={el.adminMaterials}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.searchNote === "1" ? true : false}
                fieldUID={el.id}
                field="searchNote"
                value={el.searchNote}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.editApel === "1" ? true : false}
                fieldUID={el.id}
                field="editApel"
                value={el.editApel}
                onChange={changeRights}
              />
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableSecond = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Prawa: raporty</th>
        <th>Prawa: zbiorcza akceptacja terminów</th>
        <th>Prawa: płatności</th>
        <th>Prawa: administracja urlopami</th>
        <th>Prawa: urlopy</th>
        <th>Prawa: praca zdalna</th>
        <th>Prawa: ewidencja</th>
        <th>Prawa: akceptacja spraw</th>
        <th>Prawa: zbiorcza akceptacja spraw</th>
        <th>Prawa: historia do zadania</th>
        <th>Prawa: wykonanie zadania</th>
        <th>Prawa: edycja zadania</th>
        <th>Prawa: usuwanie zadania</th>
        <th>Prawa: panel administracyjny</th>
        <th>Prawa: książka nadawcza</th>
        <th>Prawa: zamykanie kontaktu</th>
        <th>Prawa: rozliczenie klienta</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.raporty === "1" ? true : false}
                fieldUID={el.id}
                field="raporty"
                value={el.raporty}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zbiorczoAkceptacjaTerminow === "1" ? true : false}
                fieldUID={el.id}
                field="zbiorczoAkceptacjaTerminow"
                value={el.zbiorczoAkceptacjaTerminow}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.platnosci === "1" ? true : false}
                fieldUID={el.id}
                field="platnosci"
                value={el.platnosci}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.urlopyAdmin === "1" ? true : false}
                fieldUID={el.id}
                field="urlopyAdmin"
                value={el.urlopyAdmin}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.urlopy === "1" ? true : false}
                fieldUID={el.id}
                field="urlopy"
                value={el.urlopy}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.urlopyZdalna === "1" ? true : false}
                fieldUID={el.id}
                field="urlopyZdalna"
                value={el.urlopyZdalna}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.ewidencja === "1" ? true : false}
                fieldUID={el.id}
                field="ewidencja"
                value={el.ewidencja}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.akceptacjaSprawy === "1" ? true : false}
                fieldUID={el.id}
                field="akceptacjaSprawy"
                value={el.akceptacjaSprawy}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.akceptacjaSprawyZb === "1" ? true : false}
                fieldUID={el.id}
                field="akceptacjaSprawyZb"
                value={el.akceptacjaSprawyZb}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieHistoria === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieHistoria"
                value={el.zadanieHistoria}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieWykonanie === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieWykonanie"
                value={el.zadanieWykonanie}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieEdycja === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieEdycja"
                value={el.zadanieEdycja}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zadanieUsun === "1" ? true : false}
                fieldUID={el.id}
                field="zadanieUsun"
                value={el.zadanieUsun}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.superAdmin === "1" ? true : false}
                fieldUID={el.id}
                field="superAdmin"
                value={el.superAdmin}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.postBook === "1" ? true : false}
                fieldUID={el.id}
                field="postBook"
                value={el.postBook}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.zamKon === "1" ? true : false}
                fieldUID={el.id}
                field="zamKon"
                value={el.zamKon}
                onChange={changeRights}
              />
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "0px" }}
            >
              <input
                style={{ width: "15px" }}
                id="checkCal2"
                type="checkbox"
                checked={el.rozCli === "1" ? true : false}
                fieldUID={el.id}
                field="rozCli"
                value={el.rozCli}
                onChange={changeRights}
              />
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableThird = (
    <table
      style={{ width: "100%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Adres e-mail</th>
        <th>Numer telefonu</th>
        <th>Login</th>
        <th>Hasło</th>
        <th>Inicjały</th>
        <th>Rola</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.name}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.name}
                    fieldUID={el.id}
                    field="name"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    desc={el.initials}
                    value={el.name}
                    fieldUID={el.id}
                    field={el.name}
                    onClick={deleteUserAccept}
                  >
                    <FontAwesomeIcon icon={faDeleteLeft} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.mail}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.mail}
                    fieldUID={el.id}
                    field="mail"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.phone}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.phone}
                    fieldUID={el.id}
                    field="phone"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.login}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.login}
                    fieldUID={el.id}
                    field="login"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.password}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.password}
                    fieldUID={el.id}
                    field="password"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "center", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.initials}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    value={el.initials}
                    fieldUID={el.id}
                    field="initials"
                    desc={""}
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "center", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.role}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    value={el.role}
                    fieldUID={el.id}
                    field="role"
                    onClick={changeRightsRole}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableFourth = (
    <table
      style={{ width: "65%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Uprawnienia do spraw</th>
        <th>Zespół</th>
        <th>Zespół dla modułu urlopów</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.allowedClients}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={
                      'wprowadź "all", jeżeli nadajesz uprawnienia do wszystkich spraw, w przeciwnym razie wprowadź ID spraw po przecinku.'
                    }
                    value={el.allowedClients}
                    fieldUID={el.id}
                    field="allowedClients"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.team}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.team}
                    fieldUID={el.id}
                    field="team"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {el.urlop_zespol}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    value="sign_aggr"
                    desc={""}
                    value={el.urlop_zespol}
                    fieldUID={el.id}
                    field="urlop_zespol"
                    onClick={changeRightsText}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  const usersTableFifth = (
    <table
      style={{ width: "65%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Użytkownik</th>
        <th>Zespół</th>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {1}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend.filter((el) => +el.team === 1)[0] === undefined
                ? ""
                : usersSend.filter((el) => +el.team === 1)[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"1"}
                fieldUID={"1"}
                field="urlop_zespol"
                onClick={changeRightsUser}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
        <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
          {1}
        </td>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {2}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend.filter((el) => +el.team === 2)[0] === undefined
                ? ""
                : usersSend.filter((el) => +el.team === 2)[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"2"}
                fieldUID={"2"}
                field="urlop_zespol"
                onClick={changeRightsUser}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
        <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
          {2}
        </td>
      </tr>
    </table>
  );

  const usersTableFifthA = (
    <table
      style={{ width: "65%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Użytkownik</th>
        <th>Zespół</th>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {1}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend2.filter((el) => +el.team === 1)[0] === undefined
                ? ""
                : usersSend2.filter((el) => +el.team === 1)[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"1"}
                fieldUID={"1"}
                field="urlop_zespol"
                onClick={changeRightsUser2}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
        <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
          {1}
        </td>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {2}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend2.filter((el) => +el.team === 2)[0] === undefined
                ? ""
                : usersSend2.filter((el) => +el.team === 2)[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"2"}
                fieldUID={"2"}
                field="urlop_zespol"
                onClick={changeRightsUser2}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
        <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
          {2}
        </td>
      </tr>
    </table>
  );

  const usersTableFifthC = (
    <table
      style={{ width: "65%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Użytkownik</th>
        <th>Zespół</th>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {1}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend4.filter((el) => +el.team === 1)[0] === undefined
                ? ""
                : usersSend4.filter((el) => +el.team === 1)[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"1"}
                fieldUID={"1"}
                field="urlop_zespol"
                onClick={changeRightsUser4}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
        <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
          {1}
        </td>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {2}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend4.filter((el) => +el.team === 2)[0] === undefined
                ? ""
                : usersSend4.filter((el) => +el.team === 2)[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"2"}
                fieldUID={"2"}
                field="urlop_zespol"
                onClick={changeRightsUser4}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
        <td style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}>
          {2}
        </td>
      </tr>
    </table>
  );

  const usersTableSixth = (
    <table
      style={{ width: "65%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Użytkownik</th>
        <th>Zespół</th>
      </tr>
      {users
        .filter((el) => el.sprzedazZlecSprawe === "1")
        .map((user) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                {user.id}
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.name}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.teamFinish}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="sign_aggr"
                      desc={""}
                      value={user.teamFinish}
                      fieldUID={user.id}
                      field="teamFinish"
                      onClick={changeRightsText}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
    </table>
  );

  const usersTableFifthB = (
    <table
      style={{ width: "65%" }}
      id="detailClientTable"
      className="clients_table"
    >
      <tr>
        <th>Lp.</th>
        <th>Użytkownik</th>
      </tr>
      <tr>
        <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
          {1}
        </td>
        <td style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              width: "90%",
            }}
          >
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "left",
              }}
            >
              {usersSend3[0] === undefined ? "" : usersSend3[0].user}
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <button
                style={{
                  marginLeft: "10px",
                  width: "10%",
                  backgroundColor: "transparent",
                  color: "#a5bea4",
                  border: "none",
                  fontSize: "1vw",
                }}
                id="clientsButton"
                className="paymentMenuButton"
                value="sign_aggr"
                desc={""}
                value={"1"}
                fieldUID={"1"}
                field="urlop_zespol"
                onClick={changeRightsUser3}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>
        </td>
      </tr>
    </table>
  );

  const insertConfigRow = async (e) => {
    var table = "substitutes";

    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/addTaskReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const insertConfigRow2 = async (e) => {
    var model = [];
    var team = e.currentTarget.value;

    users
      .filter((el) => el.team.includes(team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;
        var mail = users.filter((el) => el.name === us)[0].mail;

        var body = {
          user: us,
          mail: mail,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addSygnReport", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const insertConfigRow3 = async (e) => {
    var model = [];

    users.map((element) => {
      model[element.name] = element.name;
    });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;
        var mail = users.filter((el) => el.name === us)[0].mail;

        var body = {
          user: us,
          mail: mail,
          id: e,
        };

        console.log(body);

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend5", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const insertConfigRow4 = async (e) => {
    var model = [];

    users.map((element) => {
      model[element.name] = element.name;
    });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;
        var mail = users.filter((el) => el.name === us)[0].mail;

        var body = {
          user: us,
          mail: mail,
          id: e,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend6", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const insertConfigRow5 = async (e) => {
    var model = [];

    users.map((element) => {
      model[element.name] = element.name;
    });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;
        var mail = users.filter((el) => el.name === us)[0].mail;

        var body = {
          user: us,
          mail: mail,
          id: e,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateUsersSend7", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const insertConfigRow6 = async (e) => {
    var model = [];
    var team = e.currentTarget.value;

    users
      .filter((el) => el.team.includes(team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var us = result.value;
        var mail = users.filter((el) => el.name === us)[0].mail;

        var body = {
          user: us,
          mail: mail,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addSTSReport", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const deleteConfigRow = async (e) => {
    var table = "substitutes";

    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteTaskReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const deleteConfigRow2 = async (e) => {
    var table = "sygnReportUsers";

    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSygnReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const deleteConfigRow3 = async (e) => {
    var table = "sygnReportUsers";

    var body = {
      id: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSTSReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const usersTableSeventh1 = (
    <>
      <button
        style={{
          marginTop: "2vh",
          marginBottom: "2vh",
          backgroundColor: "green",
        }}
        className="closeClientButton"
        onClick={insertConfigRow}
      >
        DODAJ
      </button>
      <table
        style={{ width: "65%" }}
        id="detailClientTable"
        className="clients_table"
      >
        <tr>
          <th>Lp.</th>
          <th>Użytkownik raportowany</th>
          <th>Odbiorcy raportu</th>
        </tr>
        {taskReport.map((user, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      desc={""}
                      value={user.id}
                      fieldUID={user.id}
                      field="userName"
                      onClick={deleteConfigRow}
                    >
                      <FontAwesomeIcon icon={faDeleteLeft} />
                    </button>
                  </div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.userName}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="userName"
                      desc={""}
                      value={user.userName}
                      fieldUID={user.id}
                      field="userName"
                      onClick={changeRightsText1}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.recipName}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="recipName"
                      desc={""}
                      value={user.recipName}
                      fieldUID={user.id}
                      field="recipName"
                      onClick={changeRightsText1}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const usersTableSeventh2 = (
    <>
      <button
        style={{
          marginTop: "2vh",
          marginBottom: "2vh",
          backgroundColor: "green",
        }}
        className="closeClientButton"
        onClick={insertConfigRow2}
      >
        DODAJ
      </button>
      <table
        style={{ width: "65%" }}
        id="detailClientTable"
        className="clients_table"
      >
        <tr>
          <th>Lp.</th>
          <th>Użytkownik</th>
          <th>Adres e-mail</th>
        </tr>
        {sygnReport.map((user, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.user}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.mail}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      desc={""}
                      value={user.id}
                      fieldUID={user.id}
                      field="userName"
                      onClick={deleteConfigRow2}
                    >
                      <FontAwesomeIcon icon={faDeleteLeft} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const usersTableSeventh6 = (
    <>
      <button
        style={{
          marginTop: "2vh",
          marginBottom: "2vh",
          backgroundColor: "green",
        }}
        className="closeClientButton"
        onClick={insertConfigRow6}
      >
        DODAJ
      </button>
      <table
        style={{ width: "65%" }}
        id="detailClientTable"
        className="clients_table"
      >
        <tr>
          <th>Lp.</th>
          <th>Użytkownik</th>
          <th>Adres e-mail</th>
        </tr>
        {stsReport.map((user, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.user}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.mail}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      desc={""}
                      value={user.id}
                      fieldUID={user.id}
                      field="userName"
                      onClick={deleteConfigRow3}
                    >
                      <FontAwesomeIcon icon={faDeleteLeft} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const usersTableSeventh4 = (
    <>
      <table
        style={{ width: "65%" }}
        id="detailClientTable"
        className="clients_table"
      >
        <tr>
          <th>Lp.</th>
          <th>Użytkownik</th>
          <th>Zespół</th>
          <th>Adres e-mail</th>
        </tr>
        {usersSend6.map((user, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.user}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.team}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.mail}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value="userName"
                      desc={""}
                      value={user.id}
                      field="userName"
                      onClick={(e) => {
                        insertConfigRow4(user.id);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const usersTableSeventh3 = (
    <>
      <table
        style={{ width: "65%" }}
        id="detailClientTable"
        className="clients_table"
      >
        <tr>
          <th>Lp.</th>
          <th>Użytkownik</th>
          <th>Zespół</th>
          <th>Adres e-mail</th>
        </tr>
        {usersSend5.map((userX, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {userX.user}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {userX.team}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {userX.mail}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={userX.id}
                      onClick={(e) => {
                        insertConfigRow3(userX.id);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const usersTableSeventh5 = (
    <>
      <table
        style={{ width: "65%" }}
        id="detailClientTable"
        className="clients_table"
      >
        <tr>
          <th>Lp.</th>
          <th>Użytkownik</th>
          <th>Zespół</th>
          <th>Adres e-mail</th>
        </tr>
        {usersSend7.map((user, index) => (
          <>
            <tr>
              <td
                style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {index + 1}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.user}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "20%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.team}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  ></div>
                </div>
              </td>
              <td
                style={{ width: "5%", textAlign: "left", paddingLeft: "10px" }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    width: "90%",
                  }}
                >
                  <div
                    style={{
                      width: "80%",
                      display: "flex",
                      justifyContent: "left",
                    }}
                  >
                    {user.mail}
                  </div>
                  <div
                    style={{
                      width: "20%",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <button
                      style={{
                        marginLeft: "10px",
                        width: "10%",
                        backgroundColor: "transparent",
                        color: "#a5bea4",
                        border: "none",
                        fontSize: "1vw",
                      }}
                      id="clientsButton"
                      className="paymentMenuButton"
                      value={user.id}
                      onClick={(e) => {
                        insertConfigRow5(user.id);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const insertUser = async (e) => {
    MySwal.fire({
      title: "Wprowadź login",
      text: "po dodaniu użytkownika dodawj wszystkie wymagane do pracy pola",
      input: "text",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          login: value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertUser", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <button
              style={{
                marginTop: "2vh",
                backgroundColor: "green",
                marginBottom: "3vh",
              }}
              className="closeClientButton"
              onClick={insertUser}
            >
              DODAJ
            </button>
            <div
              style={{
                height: "5vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Uprawnienia cz. 1
            </div>
            {usersTableFirst}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Uprawnienia cz. 2
            </div>
            {usersTableSecond}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Uprawnienia cz. 3
            </div>
            {usersTableSeventh}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Dane użytkowników
            </div>
            {usersTableThird}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Dostęp do spraw i zespoły
            </div>
            {usersTableFourth}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Wysyłka pozwu dla użytkowników z ograniczeniami dostępu
            </div>
            {usersTableFifth}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Nadanie pozwu
            </div>
            {usersTableFifthA}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Weryfikacja czy sąd zarządził doręczenie pozwu stronie przeciwnej
            </div>
            {usersTableFifthC}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Finalne sprawdzenie
            </div>
            {usersTableFifthB}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Zespół dla zakładania sprawy
            </div>
            {usersTableSixth}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Raporty zadań
            </div>
            {usersTableSeventh1}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Raporty sygnatur z PI
            </div>
            {usersTableSeventh2}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Raporty "Sędzia: teoria salda"
            </div>
            {usersTableSeventh6}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Użytkownik do zadania "Opłata od pozwu"
            </div>
            {usersTableSeventh3}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Użytkownik do zadania "Rozważ ponaglenie w sprawie" i "Rozważ
              wysyłkę prezentu"
            </div>
            {usersTableSeventh4}
            <div
              style={{
                height: "5vh",
                marginTop: "3vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Użytkownik do maila ze zleceniem założenia sprawy - zespół 1
            </div>
            {usersTableSeventh5}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelUsers;
